import { gql } from '@apollo/client'

import { Patient } from '@/fragments'

export default gql`
  mutation registerUser(
    $agreed_terms_and_conditions: Int!
    $patient: UserRegistrationInput!
  ) {
    registerUser(
      agreed_terms_and_conditions: $agreed_terms_and_conditions
      patient: $patient
    ) {
      ...patient
    }
  }
  ${Patient}
`
